import '../Trusted Banner/trusted-banner.css';

export default function TrustedBanner() {
  return (
    <section>
      <div id="braveTrustedSection">
        <a id="braveTrustedContainer" href="/pages/real-reviews-by-real-people">
          <h2>TRUSTED BY 250,000+ FAMILIES</h2>
          <img
            loading="eager"
            width="100"
            height="20"
            alt="4.5 yellow stars"
            src="https://cdn.shopify.com/s/files/1/0564/9032/8257/files/4-5-stars_copy.webp?v=1761678906"
          />
        </a>
      </div>
    </section>
  );
}
